/**
 * global.js — Comportements globaux du thème
 * - Drawer mobile (accessible)
 * - Header sticky / shrink / transparent au scroll
 * - Boutons magnetic
 * - Recommandations produit (Section Rendering API)
 */

(function () {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ─── Mobile drawer ────────────────────────────────────────
  const drawer       = document.querySelector('[data-drawer]');
  const drawerToggle = document.querySelector('[data-drawer-toggle]');
  const drawerCloses = document.querySelectorAll('[data-drawer-close]');

  let lastFocused = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    drawerToggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('drawer-open');

    const firstFocusable = drawer.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
    firstFocusable?.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawerToggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('drawer-open');
    lastFocused?.focus();
  }

  drawerToggle?.addEventListener('click', () => {
    const isOpen = drawer?.getAttribute('aria-hidden') === 'false';
    isOpen ? closeDrawer() : openDrawer();
  });

  drawerCloses.forEach((el) => el.addEventListener('click', closeDrawer));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer?.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });

  // ─── Header scroll behavior ──────────────────────────────
  const header = document.querySelector('[data-site-header]');

  // La barre d'annonce reste dans le flux : on expose sa hauteur pour que
  // le header transparent (position: absolute) se place juste en dessous.
  const announcement = document.querySelector('.announcement-bar');
  function syncAnnouncementHeight() {
    const h = announcement ? announcement.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-h', h + 'px');
  }
  if (announcement) {
    syncAnnouncementHeight();
    window.addEventListener('resize', syncAnnouncementHeight, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(syncAnnouncementHeight).observe(announcement);
    }
  }

  if (header) {
    const isTransparent = header.classList.contains('site-header--transparent');
    const threshold = isTransparent ? 80 : 20;
    let ticking = false;

    function onScroll() {
      const scrolled = window.scrollY > threshold;
      header.classList.toggle('is-scrolled', scrolled);
      if (isTransparent) header.classList.toggle('is-stuck', scrolled);
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });

    onScroll();
  }

  // ─── Magnetic buttons ────────────────────────────────────
  if (!prefersReducedMotion) {
    const magnetics = document.querySelectorAll('[data-magnetic]');
    magnetics.forEach((el) => {
      const strength = parseFloat(el.dataset.magnetic) || 0.3;

      el.addEventListener('mousemove', (e) => {
        const rect = el.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        el.style.transform = `translate(${x * strength}px, ${y * strength}px)`;
      });

      el.addEventListener('mouseleave', () => {
        el.style.transform = '';
      });
    });
  }

  /* === Recommandations produit ===
     Shopify ne calcule les recommandations que sur appel : la section
     rend d'abord un conteneur vide qu'on remplace par le HTML reçu. */
  const recoHost = document.querySelector('[data-reco-url]');
  if (recoHost) {
    fetch(recoHost.dataset.recoUrl)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((html) => {
        const recu = new DOMParser().parseFromString(html, 'text/html');
        const section = recu.querySelector('.product-recommendations');
        if (!section) return;
        recoHost.replaceWith(section);
        // L'observer de taste-animations.js a déjà tourné : on révèle à la main
        // les éléments injectés après coup.
        section.querySelectorAll('[data-taste]').forEach((el) => el.classList.add('is-visible'));
      })
      .catch(() => {
        recoHost.remove();
      });
  }

})();
